<div mat-dialog-content class="dialog-container ">
	<mat-icon class="close-icon" (click)="onCloseClick()">close</mat-icon>
	<div class="image-container">
		<!-- hELLO -->
		<img [src]="srcImage" class="centered-image"
			onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'">
	</div>
</div>
